import React from 'react';

import GoogleAnalyticsScript from './GoogleAnalyticsScript';
import MicrosoftClarityScript from './MicrosoftClarityScript';

const ThirdPartyScripts = () => (
  <>
    <GoogleAnalyticsScript />
    <MicrosoftClarityScript />
  </>
);

export default ThirdPartyScripts;
